import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.scss";
import "./assets/css/style.scss";
import ScrollToTop from "./scrollToTop";

import { ToastContainer } from "react-toastify";

import ProtectedRoute from "./ProtectedRoutes";
import { appRoutes } from "./routes";

export const server = process.env.REACT_APP_SERVER_URL;

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer closeOnClick />

      <Routes>
        {appRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <ProtectedRoute roles={route.roles}>
                {route.element}
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
    </Router>
  );
}

export default App;
